import clientService from '@services/client';

export const getClientChannelsSuccess = (clientChannels) => ({
  type: 'CLIENT_CHANNELS_SUCCESS',
  clientChannels,
});

export const getClientChannelsError = () => ({
  type: 'CLIENT_CHANNELS_FAILURE',
});

export const getClientChannels = () =>
  function (dispatch) {
    dispatch({
      type: 'CLIENT_CHANNELS_REQUEST',
    });
    return clientService.getClientChannels();
  };
